/**
 * クリックハンドラの登録システム
 * 新しいハンドラを簡単に追加可能
 */
const clickHandlers = [];

/**
 * クリックハンドラを登録
 * @param {object} handler
 * @param {string} handler.selector - 対象セレクタ
 * @param {function} handler.callback - (element, event) => void
 * @param {number} [handler.priority=0] - 実行優先度（大きいほど優先）
 */
export function registerClickHandler(handler) {
    if (!handler.selector || typeof handler.callback !== 'function') {
        console.error('[ClickHandler] Invalid handler:', handler);
        return;
    }

    clickHandlers.push({
        selector: handler.selector,
        callback: handler.callback,
        priority: handler.priority || 0,
    });

    // 優先度順にソート
    clickHandlers.sort((a, b) => b.priority - a.priority);
}

/**
 * 統一クリックイベントハンドラの初期化
 */
export function initUnifiedClickHandler(root = document) {
    if (!root || typeof root.addEventListener !== 'function') {
        return;
    }

    root.addEventListener('click', async (event) => {
        // 登録されたハンドラを順に実行
        for (const handler of clickHandlers) {
            const element = event.target.closest(handler.selector);
            if (!element) continue;

            try {
                await handler.callback(element, event);
                // ハンドラが処理した場合はここで終了（最初にマッチしたもの優先）
                break;
            } catch (error) {
                console.error(`[ClickHandler] Error in ${handler.selector}:`, error);
            }
        }
    }, false);
}

